module.exports = __webpack_public_path__ + "img/inside-back.2ba1acd2.png";